import { render, staticRenderFns } from "./ModalGenerico.vue?vue&type=template&id=4fd85e70&scoped=true"
import script from "./ModalGenerico.vue?vue&type=script&lang=js"
export * from "./ModalGenerico.vue?vue&type=script&lang=js"
import style0 from "./ModalGenerico.vue?vue&type=style&index=0&id=4fd85e70&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd85e70",
  null
  
)

export default component.exports